import { BookingItem } from "@/stores/bookingData";

// const bookingData = useBookingDataStore();

export function getTotalPrice(services: BookingItem[], foods: BookingItem[], drinks: BookingItem[], options: BookingItem[], discount = 0) {
  console.log('getTotalPrice', services, foods);
  const total = (services.reduce((total, service) => total +
    (service.quantity > 0 ? (parseFloat(service.packagePrice.replaceAll(',', '.').replaceAll(' ', '')) || 0) + service.quantity * (parseFloat(service.unitPrice.replaceAll(',', '.').replaceAll(' ', '')) || 0) : 0)
    , 0)
    + foods.reduce((total, food) => total +
      (food.activated ? food.quantity * (parseFloat(food.packagePrice.replaceAll(',', '.').replaceAll(' ', '')) || 0) : 0)
      , 0)
    + drinks.reduce((total, drink) => total +
      (drink.activated ? drink.quantity * (parseFloat(drink.packagePrice.replaceAll(',', '.').replaceAll(' ', '')) || 0) : 0)
      , 0)
    + options.reduce((total, option) => total +
      (option.activated ? option.quantity * (parseFloat(option.packagePrice.replaceAll(',', '.').replaceAll(' ', '')) || 0) : 0)
      , 0));
  return (total * (1-discount)).toFixed(2);
}

/*export function totalBookingPrice() {
  return getTotalPrice(bookingData.services);
}*/

export function mapItemToBookingItem(item: any, quantity: number, options: BookingItem[] = []): BookingItem {
  return {
    id: item.Id,
    activated: true,
    quantity,
    packagePrice: item.Prix,
    unitPrice: item['Prix par personne'],
    options,
    meta: item
  }
}

// Build the booking item for a noon ("service de midi") reservation. Noon
// reuses the diner room products for pricing: the price comes from the selected
// room (options[0]), and noon is billed flat per booking — there is no
// per-person line. The booking id stays `noon` (drives activity_type and the
// order item); only the price is sourced from the room.
//
// unitPrice is forced to '0': mapItemToBookingItem copies the noon catalog
// row's `Prix par personne`, but the backend bills noon at quantity 1 with no
// per-person line, so leaving a non-zero per-person value would make
// getTotalPrice (packagePrice + quantity * unitPrice) over-state the total.
export function buildNoonBookingItem(noonSvc: any, quantity: number, options: BookingItem[]): BookingItem {
  const booking = mapItemToBookingItem(noonSvc, quantity, options);
  booking.packagePrice = options[0].packagePrice;
  booking.unitPrice = '0';
  return booking;
}
